$ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var BrandSorter = function () {
	this.filterElement = $('#dk-woo-ajax-navigation-brands-facet');
	this.first_load = 1;
};

BrandSorter.prototype.init = function () {
	var self = this;

	$(document).on('facetwp-loaded', function() {
        self.groupfwp();
		self.nameFilter();
    });
	$(window).on('load', function() {
        self.groupfwp();
		self.nameFilter();
		
		if ( self.first_load == 1 && $( 'body.tax-product_cat' ).length > 0 ) {
			
			if ( $( '.facetwp-facet-big_brands' ).length > 0 && $( '.facetwp-facet-big_brands .facetwp-radio' ).length == 1 ) {
				$( '#dk-woo-ajax-navigation-brands-facet' ).remove();
			}
			
			self.first_load = 0;
		}
    });

};

BrandSorter.prototype.refresh = function () {


};

BrandSorter.prototype.nameFilter = function () {
	var self = this;
	
	if ( self.filterElement.find( '.facetwp-radio.checked' ).length > 0 ) {
		self.filterElement.find( 'h2.widgettitle' ).addClass( 'active_filter' ).html( '<span class="remove brand" title="fjerne"></span>'+ self.filterElement.find( '.facetwp-radio.checked' ).contents().filter(function() { return this.nodeType == 3; }).text() );
		$('.remove.brand').on( 'click', function() {
			$( '.facetwp-facet-big_brands div.facetwp-radio' ).removeClass( 'checked' );
			FWP.refresh();
		});
		
	} else {
		self.filterElement.find( 'h2.widgettitle' ).removeClass( 'active_filter' ).text( 'Merker' );
	}
}

BrandSorter.prototype.groupfwp = function () {
	
	var letters = new Array();
	letters['0-9'] = 1;
	letters['Æ'] = 1;
	letters['Ø'] = 1;
	letters['Å'] = 1;
	
	var a = 65;
	
	
	for (var i = 0; i<26; i++) {
		letters[String.fromCharCode(a + i)] = 1;
	}
	
	if ($('.facetwp-facet-big_brands.facetwp-type-radio h3').length == 0) {
		$('.facetwp-facet-big_brands .facetwp-radio').each(function( index ) {
			
			
			if ( $(this).text().charAt(0).match(/[0-9]/i) && letters['0-9'] == 1 ) {
				letters['0-9'] = 0;
				$(this).before('<hr /><h3 class="letters_split">#</h3>');
			}
			
			for (var i = 0; i<26; i++) {
				
				if ( $(this).text().charAt(0).toUpperCase() == String.fromCharCode(a + i) && letters[String.fromCharCode(a + i)] == 1 ) {
					letters[String.fromCharCode(a + i)] = 0;
					$(this).before( '<hr /><h3 class="letters_split">' + String.fromCharCode(a + i) + '</h3>' );
				}
				
			}
			
			if ( $(this).text().charAt(0).toUpperCase() == 'Æ' && letters['Æ'] == 1 ) {
				letters['Æ'] = 0;
				$(this).before( '<hr /><h3 class="letters_split">Æ</h3>' );
			}
			
			if ( $(this).text().charAt(0).toUpperCase() == 'Ø' && letters['Ø'] == 1 ) {
				letters['Ø'] = 0;
				$(this).before( '<hr /><h3 class="letters_split">Ø</h3>' );
			}
			
			if ( $(this).text().charAt(0).toUpperCase() == 'Å' && letters['Å'] == 1 ) {
				letters['Å'] = 0;
				$(this).before( '<hr /><h3 class="letters_split">Å</h3>' );
			}
			
		});
	}
}

module.exports = new BrandSorter();
